import intl from 'react-intl-universal';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';

const userNameColumn = () => {
  return {
    accessorKey: 'username',
    header: intl.get('organization_settings_user_management_label_username'),
    enableColumnFilter: false,
    enableSorting: true,
    enableColumnActions: false,
  };
};

const userFullNameColumn = () => {
  return {
    accessorKey: 'userFullName',
    header: intl.get(
      'organization_settings_user_management_label_user_full_name'
    ),
    enableColumnFilter: false,
    enableSorting: true,
    enableColumnActions: false,
  };
};

const emailColumn = () => {
  return {
    accessorKey: 'email',
    header: intl.get('register_label_email'),
    enableColumnFilter: false,
    enableSorting: true,
    enableColumnActions: false,
  };
};

const privilegeColumn = (setPrivilegeDetails, setPrivilegeDetailsModalOpen) => {
  return {
    accessorKey: 'privilege',
    header: intl.get('organization_settings_user_management_label_privilege'),
    enableSorting: false,
    enableColumnFilter: false,
    enableColumnActions: false,
    muiTableBodyCellProps: {
      onClick: (e) => e.stopPropagation(),
    },
    Cell: ({ renderedCellValue }) => {
      return privilegeCell({
        renderedCellValue,
        setPrivilegeDetails,
        setPrivilegeDetailsModalOpen,
      });
    },
  };
};

const privilegeCell = ({
  renderedCellValue,
  setPrivilegeDetails,
  setPrivilegeDetailsModalOpen,
}) => {
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={() => {
        setPrivilegeDetails(renderedCellValue);
        setPrivilegeDetailsModalOpen(true);
      }}>
      {intl.get(
        'organization_settings_user_management_button_privilege_details'
      )}
    </Button>
  );
};

privilegeCell.propTypes = {
  renderedCellValue: PropTypes.object.isRequired,
  setPrivilegeDetails: PropTypes.func.isRequired,
  setPrivilegeDetailsModalOpen: PropTypes.func.isRequired,
};

export const userManagementColumns = (
  setPrivilegeDetails,
  setPrivilegeDetailsModalOpen
) => {
  return [
    userNameColumn(),
    userFullNameColumn(),
    emailColumn(),
    privilegeColumn(setPrivilegeDetails, setPrivilegeDetailsModalOpen),
  ];
};
